// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__0RNWX","dashboard":"Dashboard_dashboard__GRmXJ","editButton":"Dashboard_editButton__k14Il"};